import React from 'react';
import {
    Typography,
    withStyles,
    RadioGroup,
    Radio,
    FormControlLabel,
    makeStyles
} from '@material-ui/core';

import classes from './LevelQeustion.module.css';

const StyledLabel = withStyles({
    root: {
        marginRight: "0",
        marginLeft: "0"
    },
    label: {
        fontSize: ".8rem"
    }
})(FormControlLabel)

const makeRadioGroupStyle = makeStyles({
    root: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingTop: "1.5rem"

    }
})



function LevelQuestion(props) {
    const radioGroupStyle = makeRadioGroupStyle()


    const img = props.img ?
        (<img src={props.img} alt="" style={{
            width: "100%",
            height: "auto",
            margin: "1rem 0"
        }} />) :
        null;

    const optionsLabel = [
        "完全不符合",
        "不符合",
        "普通",
        "符合",
        "完全符合"
    ]

    const options = [...new Array(5)].map((ele, i) => {
        return <StyledLabel value={`${i}`} control={<Radio />} key={i} label={optionsLabel[i]} labelPlacement="top" />
    })

    return (
        <div style={{
            width: "80%",
            marginBottom: "1.5rem",
            textAlign: "center"
        }}>
            <Typography
                display="block"
                variant="body2"
                align="left"
                gutterBottom
            >
                <span
                    className={classes.questionOrder}>{props.id}
                </span>
                <span>{props.question}
                </span>
            </Typography>
            {img}
            <RadioGroup aria-label="gender"
                name="gender1"
                className={radioGroupStyle.root}
                // value={value}
                onChange={(event, value) => { props.sliderChange(props.id, value) }}
                value={props.defaultvalue}>
                {options}
            </RadioGroup>
            <hr style={{
                width: "100%",
                margin: "1.5rem auto 0 auto",
                border: "0.5px solid #cfcfcf",
            }} />
        </div>
    )
}

export default LevelQuestion
